import { USER_KEY } from '../constants'

export default (): string | null => {
  const { placeId } = JSON.parse(localStorage.getItem(USER_KEY) || '{}')
  return placeId
}
